import { RootState } from 'common/redux/core/root.reducer';

export const getMode = (state: RootState) => state.dataEditor.mode;

export const getFieldErrors = (state: RootState) => state.dataEditor.fieldErrors;

export const getPreviewDataDetails = (state: RootState) => state.dataEditor.previewDetails;

export const getPreviewDataDetailsApiStatus = (state: RootState) =>
    state.dataEditor.previewDetailsAPIStatus;

export const getEditData = (state: RootState) => state.dataEditor.editData;

export const getEditModalVisibility = (state: RootState) => state.dataEditor.isEditModalVisible;

export const getMessageModalDetails = (state: RootState) => state.dataEditor.messageModal;

export const getSearchList = (state: RootState) => state.dataEditor.searchList.data;

export const getErrorCount = (state: RootState) => state.dataEditor.errorCount;

export const getErrorFixedStatus = (state: RootState) => state.dataEditor.isAtleastOneErrorFixed;

export const getMessageGuide = (state: RootState) => state.dataEditor.messageGuide;

export const getMessageBanner = (state: RootState) => state.dataEditor.messageBanner;

export const getLoadToMasterStatus = (state: RootState) =>
    state.dataEditor.loadToMasterDataApiStatus;

export const getClearPreviewStatus = (state: RootState) => state.dataEditor.clearPreview.status;
